import { axios } from '@Root/API'

export const edit = ({ id, name }) => {
  return axios.put(`student-types`, { name, id })
}
